export const odluka_fiskalizacija = {
    templateId: 111,
    category: 4,
    templateTitle: 'Odluka o fiskalizaciji (Odluka o o pravilima slijednosti numeričkih brojeva računa, o poslovnim prostorima, oznakama poslovnih prostora i operatera na naplatnim uređajima)',
    templateDescription: `<p>Svaki poslovni subjekt, čak i onaj koji nema fiskalnu blagajnu i ne prima gotovinu kao sredstvo plaćanja (ne izdaje fiskalizirane račune kod plaćanja gotovinom), u pravilu je obveznik fiskalizacije te je dužan donijeti odluku o fiskalizaciji te odluku o blagajničkom maksimumu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Obveznikom fiskalizacije smatra se:</p>
    <p>1. fizička osoba obveznik poreza na dohodak po osnovi samostalne djelatnosti prema odredbama zakona kojim se uređuje porez na dohodak te</p>
    <p>2. pravna i fizička osoba koja se smatra obveznikom poreza na dobit prema zakonu kojim se uređuje porez na dobit za sve djelatnosti za koje je, prema odredbama posebnih propisa, obveznik izdavanja računa za isporuku dobra ili obavljene usluge.</p>
    
    <p><strong>Dakle, svi poduzetnici su obveznici fiskalizacije, osim poslovnih subjekata koji obavljaju sljedeće djelatnosti: </strong></p>
    <p>1. prodaja karata ili žetona za cestovni lokalni linijski prijevoz putnika u javnom prometu sukladno odlukama jedinica lokalne samouprave te prodaja karata ili žetona u zračnom, željezničkom i linijskom obalnom pomorskom prometu,</p>
    <p>2. naplata cestarine,</p>
    <p>3. punjenje naftnim derivatima aviona na avioservisima,</p>
    <p>4. prodaja vlastitih poljoprivrednih proizvoda na tržnicama i otvorenim prostorima,</p>
    <p>5. prodaja proizvoda i/ili usluga u poštanskom prometu,</p>
    <p>6. zaprimanje uplata za sudjelovanje u igrama na sreću i zabavnim igrama,</p>
    <p>7. prodaja robe ili usluga putem prodajnih automata,</p>
    <p>8. pružanje bankovnih usluga i usluga osiguranja,</p>
    <p>9. vođenja središnjeg depozitorija nematerijaliziranih vrijednosnih papira i središnjeg registra financijskih instrumenata,</p>
    <p>10. ostvareni prometi evidentirani preko mjernih instrumenata (električna energija, plin, voda, javne komunikacijske usluge i slično), od energetskih, komunalnih, elektroničkih komunikacija i drugih pravnih osoba,</p>
    <p>11. provođenja zdravstvene zaštite (sudjelovanje u troškovima zdravstvene zaštite do pune cijene zdravstvene usluge, kod izabranog doktora primarne zdravstvene zaštite i izdavanja lijekova na recept).</p>
    
    <p>Obveznici fiskalizacije imaju sljedeće obveze:</p>
    <li> uskladiti sadržaj računa sa Zakonom o fiskalizaciji u prometu gotovinom,</li>
    <li> na svakom elektroničkom naplatnom uređaju ili drugom vidnom mjestu istaknuti obavijest o obvezi izdavanja računa te obvezi kupca da preuzme i zadrži izdani račun,</li>
    <li><strong> internim aktom propisati pravila slijednosti numeričkih brojeva računa, popis poslovnih prostora te dodijeljene oznake poslovnih prostora,</strong></li>
    <li> internim aktom odrediti visinu  blagajničkog maksimuma.</li>
    <br> 
    <p><strong>Važno je naglasiti da svi gore prikazani subjekti (osim navedenih izuzetaka) moraju donijeti prethodno spomenute odluke.</strong></p>
    <p><strong>Subjekti koji provode dodatno i fiskalizaciju izdavanja (ključna razlikovna riječ: "izdavanje") računa, kod izdavanja računa koji se naplaćuju u gotovini imaju i dodatne obveze: preuzeti i koristiti digitalni certifikat za postupak fiskalizacije, izdavati račune koji sadrže Jedinstveni identifikator računa, dužan koristiti adekvatno programsko rješenje, dostaviti podatak o prostorima u kojima obavlja djelatnost, itd..</strong></p>

    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o fiskalizaciji u prometu gotovinom.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o fiskalizaciji u prometu gotovinom,',
            signature: 'Za Obveznika fiskalizacije:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Obveznik fiskalizacije),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O PRAVILIMA SLIJEDNOSTI NUMERIČKIH BROJEVA RAČUNA, O POSLOVNIM PROSTORIMA, OZNAKAMA POSLOVNIH PROSTORA I OPERATERA NA NAPLATNIM UREĐAJIMA',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Ovom Odlukom uređuje se popis poslovnih prostora s pripadajućim adresama i oznakama poslovnih prostora i operatera na naplatnim uređajima  te pravilo slijednosti numeričkih brojeva računa.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Numerički broj računa po svakom poslovnom prostoru počinje s početkom kalendarske godine, na dan 1. siječnja, od rednog broja 1 do broja „n“ na dan 31. prosinca tekuće godine poštujući pravilo slijednosti računa.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Popis svih poslovnih prostora sa oznakama, pripadajućim adresama i radno vrijeme (po radnim danima), daju se u nastavku:" },
                    { type: "text", newline: "true", content: "\r\nOznaka poslovnog prostora:"}, 
                    { type: "input", value: "", required: true },
                    { type: "text", newline: "true", content: "\r\nAdresa poslovnog prostora:"}, 
                    { type: "input", value: "", required: true },
                    { type: "text", newline: "true", content: "\r\nRadno vrijeme (po radnim danima):"}, 
                    { type: "textarea", value: "", required: true },
                ],
              }
            ]
          },
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "U poslovnom prostoru djelatnost se obavlja putem jednog naplatnog uređaja." },
                     { type: "text", newline: "true", content: "\r\nS obzirom na to da je obvezno navesti oznaku poslovnog prostora,  oznaku naplatnog uređaja i oznake operatera po svakom naplatnom uređaju,  isti se daju u nastavku: "}, 

                    { type: "text", newline: "true", content: "\r\nOznaka poslovnog prostora:"}, 
                    { type: "input", value: "", required: true },
                    { type: "text", newline: "true", content: "\r\nOznaka naplatnog uređaja:"}, 
                    { type: "input", value: "", required: true },
                    { type: "text", newline: "true", content: "\r\nOznaka operatera na naplatnom uređaju:"}, 
                    { type: "textarea", value: "", required: true },
                    { help: "Upišite ime i prezime operatera i OIB te oznaku na računu. Npr. samo ime ili ime i početno slovo prezimena, sve u vezi Opće uredbe EU o zaštiti osobnih podataka."},

                ],
              }
            ]
          },
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Slijed računa za navedeni poslovni prostor će biti kako slijedi:"},
                    { type: "textarea", value: "", required: true,   placeholder: "1/1/1, 2/1/1, 3/1/1, itd.", },

                    { help: "Ukoliko je oznaka poslovnog prostora 1 i oznaka naplatnog uređaja 1 onda unos ovdje treba izgledati ovako: 1/1/1, 2/1/1, 3/1/1, itd. ( u prikazu je dakle 1-numerički broj računa, 2-oznaka poslovnog prostora, 3-broj naplatnog uređaja)."},
                ],
              }
            ]
          },
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",         
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Poslovni prostor naznačen u odluci \r\n2) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/111_odluka_fiskalizacija.ts